import { useState, useCallback } from "react";

export const useBookingWizardState = () => {
  const [serviceSelectionComplete, setServiceSelectionComplete] =
    useState(false);
  const [dateSelectionComplete, setDateSelectionComplete] = useState(false);
  const [professionalSelectionComplete, setProfessionalSelectionComplete] =
    useState(false);

  // Reset states when selections change
  const resetDateSelection = useCallback(() => {
    setDateSelectionComplete(false);
    setProfessionalSelectionComplete(false);
  }, []);

  const resetServiceSelection = useCallback(() => {
    setServiceSelectionComplete(false);
  }, []);

  const resetProfessionalSelection = useCallback(() => {
    setProfessionalSelectionComplete(false);
  }, []);

  const handleDateContinue = useCallback(() => {
    setDateSelectionComplete(true);
  }, []);

  const handleProfessionalContinue = useCallback(() => {
    setProfessionalSelectionComplete(true);
  }, []);

  const handleServiceContinue = useCallback(() => {
    setServiceSelectionComplete(true);
  }, []);

  return {
    serviceSelectionComplete,
    dateSelectionComplete,
    professionalSelectionComplete,
    setServiceSelectionComplete,
    setDateSelectionComplete,
    setProfessionalSelectionComplete,
    resetDateSelection,
    resetServiceSelection,
    resetProfessionalSelection,
    handleDateContinue,
    handleProfessionalContinue,
    handleServiceContinue,
  };
};
